export const SHOW_MOBILE_MENU = "SHOW_MOBILE_MENU";
export const SET_IS_SHOWN = "SET_IS_SHOWN";

export function showMobileMenu(value) {
  return {
    type: SHOW_MOBILE_MENU,
    payload: value
  };
}

export function setIsShown(payload) {
  return {
    type: SET_IS_SHOWN,
    payload
  };
}



/** WEBPACK FOOTER **
 ** ./src/browser/components/HeaderResponsive/actions.js
 **/